var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoutte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "raindrops") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NEWS_DIAG-1",
    transform: "translate(-102.000000, -1056.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRODUIT",
    transform: "translate(56.000000, 969.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "raindrops-copy-2",
    transform: "translate(25.300000, 69.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7899665,33.6843027 C21.8418254,32.3526949 22.1485177,31.0434974 22.6933484,29.8279775 C23.2780949,28.3914497 24.0239094,27.0262661 24.9164117,25.7587486 C26.3822583,23.6842211 28.0089034,21.7287534 29.7812372,19.9105101 C30.1246132,19.6199737 30.4495667,19.3082314 30.7542022,18.9771014 L31.6923757,19.9105101 C33.4686354,21.7219703 35.1064624,23.6648367 36.5919928,25.7226632 C37.5208087,27.0021675 38.2959703,28.3869748 38.9014352,29.8484259 C39.442501,31.0579671 39.7428473,32.3617799 39.7856217,33.6867084 C39.8482392,36.1550533 38.9077004,38.5429378 37.1798509,40.3023628 C35.506788,42.0576183 33.1752128,43.0274282 30.7542022,42.9750872 C28.3442852,43.0145963 26.031715,42.0228416 24.3957374,40.2482347 C22.6857337,38.4982383 21.7470932,36.1338045 21.7899665,33.6843027 L21.7899665,33.6843027 Z",
    id: "raindrops"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoutte);
export default __webpack_public_path__ + "static/media/Goutte.bc6f4c6fb14e2b80aadfbd6e4e985dc5.svg";
export { ForwardRef as ReactComponent };